module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Time-schedule-a3ce1d4f1c53f62334fcb530ab92212a.svg";